import { render, staticRenderFns } from "./RankingEditModal.vue?vue&type=template&id=85c35e0a"
import script from "./RankingEditModal.vue?vue&type=script&lang=ts"
export * from "./RankingEditModal.vue?vue&type=script&lang=ts"
import style0 from "./RankingEditModal.vue?vue&type=style&index=0&id=85c35e0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports